// frontend/src/components/home/HeroVideo.js
import { useState } from "react";
import ReactPlayer from "react-player";

import HeroVideoThumb from "../../assets/images/hero-video-thumb.jpg";

import {
  trackTrailerPlay,
  trackTrailerProgress,
} from "../../analytics/analytics";

export default function HeroVideo() {
  const [playing, setPlaying] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [trackedProgress, setTrackedProgress] = useState({});

  function handlePlayClick() {
    setPlaying(true);
    trackTrailerPlay("hero");
  }

  function handleProgress(state) {
    if (!state.played) {
      return;
    }

    const percent = Math.floor(state.played * 100);

    const checkpoints = [25, 50, 75, 100];

    for (const checkpoint of checkpoints) {
      if (percent >= checkpoint && !trackedProgress[checkpoint]) {
        setTrackedProgress((prev) => ({
          ...prev,
          [checkpoint]: true,
        }));

        trackTrailerProgress(checkpoint, "hero");
      }
    }
  }

  return (
    <div
      style={{
        position: "relative",
        paddingTop: "56.25%",
        borderRadius: 18,
        overflow: "hidden",
        boxShadow: "0 0 25px rgba(0,0,0,0.6)",
      }}
    >
      <ReactPlayer
        src="https://www.youtube.com/watch?v=UyU6hAp_1rA"
        playing={playing}
        controls
        width="100%"
        height="100%"
        onProgress={handleProgress}
        style={{
          position: "absolute",
          inset: 0,
          opacity: playing ? 1 : 0,
          transition: "opacity 0.2s ease",
        }}
      />

      {!playing && (
        <>
          <img
            src={HeroVideoThumb}
            alt="Elacoria Trailer"
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />

          <button
            onClick={handlePlayClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            aria-label="Play Trailer"
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: hovered
                ? "translate(-50%, -50%) scale(1.08)"
                : "translate(-50%, -50%)",

              width: 96,
              height: 96,
              borderRadius: "50%",

              border: hovered
                ? "2px solid rgba(255,255,255,0.65)"
                : "2px solid rgba(255,255,255,0.18)",

              background: hovered ? "rgba(255,190,0,0.95)" : "rgba(0,0,0,0.28)",

              backdropFilter: "blur(6px)",

              boxShadow: hovered
                ? "0 0 35px rgba(255,190,0,0.6)"
                : "0 0 15px rgba(0,0,0,0.25)",

              cursor: "pointer",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              padding: 0,
              transition: "all 0.2s ease",
            }}
          >
            <div
              style={{
                width: 0,
                height: 0,

                borderTop: "16px solid transparent",
                borderBottom: "16px solid transparent",
                borderLeft: hovered
                  ? "26px solid white"
                  : "26px solid rgba(255,255,255,0.9)",

                transform: "translateX(3px)",

                transition: "all 0.2s ease",
              }}
            />
          </button>
        </>
      )}
    </div>
  );
}
